// ─────────────────────────────────────────────────────────────────────────────
// External References Reducer
// ─────────────────────────────────────────────────────────────────────────────
// State interface, initial state, and reducer for the externalReferences slice.
// ─────────────────────────────────────────────────────────────────────────────

import { Action, createReducer, on } from '@ngrx/store';
import { IPagination } from 'src/app/shared/models/page.model';
import { ExternalReferenceFilters, IExternalReference } from '../models/external-reference.models';
import * as externalReferencesActions from './external-references.actions';

// ── State interface ──────────────────────────────────────────────────────────

export interface ExternalReferencesState {
  references: IExternalReference[];
  metadata: IPagination | null;
  loading: boolean;
  keyword: string;
  filters: ExternalReferenceFilters;
}

// ── Initial state ────────────────────────────────────────────────────────────

export const initialExternalReferencesState: ExternalReferencesState = {
  references: [],
  metadata: null,
  loading: false,
  keyword: '',
  filters: { source: '', customer_id: null, product_id: null, create_date_from: null, create_date_to: null },
};

// ── Reducer ──────────────────────────────────────────────────────────────────

const featureReducer = createReducer(
  initialExternalReferencesState,
  on(externalReferencesActions.LoadExternalReferences, (state) => ({
    ...state,
    loading: true,
  })),
  on(externalReferencesActions.LoadExternalReferencesSuccess, (state, action) => ({
    ...state,
    loading: false,
    references: action.response.data,
    metadata: action.response.metadata,
  })),
  on(externalReferencesActions.LoadExternalReferencesError, (state) => ({
    ...state,
    loading: false,
  })),
  on(externalReferencesActions.SetExternalReferencesLoader, (state, action) => ({
    ...state,
    loading: action.isLoading,
  })),
  on(externalReferencesActions.SetExternalReferenceSearch, (state, action) => ({
    ...state,
    keyword: action.keyword,
  })),
  on(externalReferencesActions.SetExternalReferenceFilters, (state, action) => ({
    ...state,
    filters: action.filters,
  })),
);

export function externalReferencesReducer(state: ExternalReferencesState | undefined, action: Action) {
  return featureReducer(state, action);
}
